import src from "IMAGE";
export default { src, width: 65, height: 65, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
